module.exports = __webpack_public_path__ + "img/9.be05cb09.jpg";